import React from 'react'
import { useLayout } from '@dustin-web/microsite-components/src/hooks'

const BreakpointIndicator = () => {
  const { responsive } = useLayout()

  let text = ''

  if (responsive.breakpoints.min.XL) {
    text = 'XL'
  } else if (responsive.breakpoints.min.LG) {
    text = 'LG'
  } else if (responsive.breakpoints.min.MD) {
    text = 'MD'
  } else if (responsive.breakpoints.min.SM) {
    text = 'SM'
  } else {
    text = 'Below SM'
  }

  return (
    <div
      className="c-box t-blue u-px-8 u-py-8"
      style={{ position: 'fixed', bottom: '32px', left: '32px', zIndex: 100 }}>
      {text}
    </div>
  )
}

export default BreakpointIndicator
